import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { SupportRequestPayload } from '../../shared/models/support/support.interfaces';

@Injectable({
	providedIn: 'root'
})
export class SupportService {
	private readonly endpointUrl = '/support';

	private readonly httpClient = inject(HttpClient);

	/**
	 * Sends a support request to the backend.
	 *
	 * @param {SupportRequestPayload} payload - The support request payload containing the message.
	 * @return {Observable<void>} An observable that completes when the request is sent successfully.
	 */
	public sendRequest(payload: SupportRequestPayload): Observable<void> {
		return this.httpClient.post<void>(`${this.endpointUrl}/send-request`, payload);
	}
}

